import { render, staticRenderFns } from "./redirect.vue?vue&type=template&id=62d4e7f6&"
import script from "./redirect.vue?vue&type=script&lang=js&"
export * from "./redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62d4e7f6')) {
      api.createRecord('62d4e7f6', component.options)
    } else {
      api.reload('62d4e7f6', component.options)
    }
    module.hot.accept("./redirect.vue?vue&type=template&id=62d4e7f6&", function () {
      api.rerender('62d4e7f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/redirect.vue"
export default component.exports